export default "../images/attraction-5.jpg";